import React from "react";
import styled from "styled-components/macro";
import ReactTooltip from "react-tooltip";
import { SystemDefaultIcon } from "../../../../../components/Icons/Icons";
import { useTranslation } from "react-i18next";
import { spacingTokens } from "../../../../../designTokens";

/**
 * Shared page-content padding for the group/collection detail pages, plus a
 * border-bottom override for the stacked AccordionCard-in-WhiteInnerCard
 * layout those pages use. The selector targets portalPageLayout's generated
 * class name by substring match — keep it in sync if that component's
 * markup structure changes.
 */
export const PageContentWrapper = styled.div`
  padding: 0 ${spacingTokens.spacing_xl};
  .accordion-content-wrapper {
    padding-bottom: 0;
    padding-top: 0;
    border-bottom: none;
  }
  div[class*="portalPageLayout__WhiteInnerCard"]
    > div:first-child
    > div:first-child {
    border-bottom: none !important;
  }
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
`;
export const SystemIconWrapper = styled.div`
  display: inline-block;
  width: 24px;
  height: 24px;
  padding-top: 1px;
  margin-left: ${({ theme }) => theme.resolve("spacing_md")};
`;
export const NameWithSystemDefaultIcon = ({
  id,
  name,
  is_system,
}: {
  name: string;
  is_system: boolean;
  id: string;
}) => {
  const { t } = useTranslation();
  return (
    <NameContainer>
      {name ?? "--"}
      <SystemIconWrapper data-for={id} data-tip={t("System Default")}>
        {is_system && <SystemDefaultIcon width={18} height={18} />}
      </SystemIconWrapper>
      {is_system && <ReactTooltip id={id} />}
    </NameContainer>
  );
};

const nonAlphanumericCharacters = /[^a-z0-9]/gi;

/**
 * only used for multiline entry attributes, because quill is known to crash
 * with any `&` in the naem with a message about invalid dom selector
 */
export const normalizeAttributeName = (name: string): string =>
  name.replace(nonAlphanumericCharacters, "_");
